export { default as RecoverInvitation } from './RecoverInvitation';
export type { RecoverInvitationProps } from './RecoverInvitation';
